'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createTestEvent = undefined;

var _analyticsNext = require('@atlaskit/analytics-next');

var createTestEvent = exports.createTestEvent = function createTestEvent() {
    var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { payload: { action: 'thisIsADumyAction' } };
    return new _analyticsNext.UIAnalyticsEvent(payload);
};